"use strict";

PF.Preloader = class Preloader extends PF.Widget
{
    static get options()
    {
        //~ this.filesInitFlag = new PF.Preloader({ dom: { element: } }); this.filesInitFlag.loader = false
        return {
            loader: true,
            dom: {},
            html: PF.Slider.templates,
        };
    }

    static get templates()
    {
        return {
            //language=HTML
            content: /*html*/`
                <div class="preloader-wrapper" pf="preloader" style="width: fit-content; margin: auto;">
                    <div class="preloader" style="margin:40px auto; ">
                        <span class="preloader-inner">
                            <span class="preloader-inner-gap"></span>
                            <span class="preloader-inner-left">
                                <span class="preloader-inner-half-circle"></span>
                            </span>
                            <span class="preloader-inner-right">
                                <span class="preloader-inner-half-circle"></span>
                            </span>
                        </span>
                    </div>
                </div>
            `,
        };
    }

    init()
    {
        this.state = 'init';
        this.dom.loads(this.html);
        this.dom.element.append(this.dom.content);
        this.bindDom({ preloader: 'show' }, 'loader');
    }
}